export const createProjectWizardMessagesEn = {
  'createProjectWizard.breadcrumb.adminProjects': 'Manage projects',
  'createProjectWizard.breadcrumb.createProject': 'Create project',
  'createProjectWizard.title': 'Create project',

  'createProjectWizard.step.basics.title': 'Basics',
  'createProjectWizard.step.conceptGroupsAndAttributes.title': 'Concept groups',
  'createProjectWizard.step.datasetImport.title': 'Dataset import',
  'createProjectWizard.step.splittingAndDriftCheck.title': 'Data splitting',
  // TODO: cleanup with cp_annotation_createproject_agent ff
  'createProjectWizard.step.annotationAgent.title': 'Annotation agent',
  'createProjectWizard.step.allocation.title': 'People & allocation',
  'createProjectWizard.step.reviewAndCreate.title': 'Review & create',

  'createProjectWizard.footer.cancel': 'Cancel',
  'createProjectWizard.footer.saveDraft': 'Save Draft',
  'createProjectWizard.footer.next': 'Next: ',
  'createProjectWizard.footer.back': 'Back',
  'createProjectWizard.footer.createProject': 'Create annotation project',
  'createProjectWizard.footer.createProject.loading': 'Creating annotation project...',

  'createProjectWizard.step.basics.projectName': 'Project name',
  'createProjectWizard.step.basics.projectNamePlaceholder': 'Eg: Asthma IDN1 Jan/2026',
  'createProjectWizard.step.basics.projectNameDescription':
    'Typically use: Condition area + Research partner + month/year',
  'createProjectWizard.step.basics.duplicate.combination':
    'A project with this name, condition area, and research partner combination already exists.',
  'createProjectWizard.step.basics.duplicate.name': 'A project with this name already exists.',
  'createProjectWizard.step.basics.conditionArea': 'Condition area',
  'createProjectWizard.step.basics.conditionAreaPlaceholder': 'Select a condition area',
  'createProjectWizard.step.basics.healthSystemName': 'Research partner',
  'createProjectWizard.step.basics.healthSystemNamePlaceholder': 'Select a research partner',

  'createProjectWizard.step.conceptGroupsAndAttributes.selectConceptGroup.placeholder':
    'Select concept group',
  'createProjectWizard.step.conceptGroupsAndAttributes.selectConceptGroup.title':
    'Similar concept group',
  'createProjectWizard.step.conceptGroupsAndAttributes.selectConceptGroup.description':
    'Search includes full library of concept groups.',
  'createProjectWizard.step.conceptGroupsAndAttributes.selectRequiredAttributes.title':
    'Required attributes',
  'createProjectWizard.step.conceptGroupsAndAttributes.selectRequiredAttributes.description':
    'Select at least 1 required attribute',
  'createProjectWizard.step.conceptGroupsAndAttributes.editcard.doneButton': 'Done',
  'createProjectWizard.step.conceptGroupsAndAttributes.editcard.removeButton': 'Remove',
  'createProjectWizard.step.conceptGroupsAndAttributes.addConceptButton': 'Add concept group',
  'createProjectWizard.step.conceptGroupsAndAttributes.addedConceptCount.chip.label':
    'Concept groups added: {count}',
  'createProjectWizard.step.conceptGroupsAndAttributes.mandatoryAttribute.chip.tooltip':
    '{attributeName} is a mandatory attribute and cannot be de-selected',
  'createProjectWizard.step.datasetImport.s3.upload.button.label': 'Save',
  'createProjectWizard.step.datasetImport.importMode.file-upload': 'File upload',
  'createProjectWizard.step.datasetImport.importMode.s3-path': 'S3 path',
  'createProjectWizard.step.datasetImport.notes.header.title': 'Upload notes file',
  'createProjectWizard.step.datasetImport.person.header.title': 'Upload person file',
  'createProjectWizard.step.datasetImport.visit.header.title': 'Upload visits file',
  'createProjectWizard.step.datasetImport.notes.s3.header.title': 'Notes',
  'createProjectWizard.step.datasetImport.notes.s3.placeholder': 'Enter notes s3 file path',
  'createProjectWizard.step.datasetImport.person.s3.header.title': 'Person',
  'createProjectWizard.step.datasetImport.person.s3.placeholder': 'Enter person s3 file path',
  'createProjectWizard.step.datasetImport.visit.s3.header.title': 'Visit',
  'createProjectWizard.step.datasetImport.visit.s3.placeholder': 'Enter visit s3 file path',
  'createProjectWizard.step.datasetImport.description':
    'Click to upload or drag and drop a parquet file',
  'createProjectWizard.step.splittingAndDriftCheck.header': 'Data splitting file',
  'createProjectWizard.step.splittingAndDriftCheck.s3.header': 'Data splitting file s3 path',
  'createProjectWizard.step.splittingAndDriftCheck.s3.placeholder':
    'Enter data splitting s3 file path',
  'createProjectWizard.step.splittingAndDriftCheck.description':
    'Click to upload or drag and drop a JSON file',
  'createProjectWizard.step.allocation.selectAnnotators.placeholder':
    'Search and select annotators',
  'createProjectWizard.step.allocation.selectSupervisors.placeholder':
    'Search and select supervisors',
  'createProjectWizard.step.allocation.selectAnnotators.title': 'Annotators',
  'createProjectWizard.step.allocation.selectSupervisors.title': 'Supervisors',
  'createProjectWizard.autocomplete.selected': 'Selected',
  'createProjectWizard.step.allocation.allocationMode.title': 'Allocation mode',
  'createProjectWizard.step.allocation.allocationMode.defaultAllocation': 'Default allocation',
  'createProjectWizard.step.allocation.allocationMode.customAllocation': 'Custom allocation',
  // TODO: cleanup with cp_disable_asym_alloc_for2_annotators ff
  'createProjectWizard.step.allocation.allocationMode.customAllocation.minAnnotatorsNote':
    'Asymmetric custom allocation requires at least 3 annotators. Encounters will be allocated 50/50 between 2 annotators.',
  'createProjectWizard.step.allocation.allocationConfiguration.trainingAllocation':
    'Training ({count} encounters)',
  'createProjectWizard.step.allocation.allocationConfiguration.testAllocation':
    'Test ({count} encounter)',
  'createProjectWizard.step.allocation.allocationConfiguration.validationAllocation':
    'Validation ({count} encounter)',
  'createProjectWizard.step.allocation.allocationConfiguration.totalMustBe100Percent':
    'Percentages must add up to 100%',
  'createProjectWizard.step.allocation.allocationConfiguration.defaultAllocationMode.description':
    'Default allocation: Encounters will be evenly allocated across annotators. All encounters are double-annotated.',
  'createProjectWizard.step.allocation.allocationConfiguration.selectAnnotator':
    'Please select at least one annotator',

  'createProjectWizard.step.conceptGroupsAndAttributes.header.title': 'Similar concept groups',
  'createProjectWizard.step.conceptGroupsAndAttributes.header.description':
    'Add similar concept groups for this project. For each concept group, select required attributes.',
  'createProjectWizard.step.reviewAndCreate.projectBasics.card.projectName': 'Project name',
  'createProjectWizard.step.reviewAndCreate.projectBasics.card.conditionArea': 'Condition area',
  'createProjectWizard.step.reviewAndCreate.projectBasics.card.healthSystem': 'Research partner',
  'createProjectWizard.step.reviewAndCreate.datasetSummary.totalEncounters': 'Total encounters',
  'createProjectWizard.step.reviewAndCreate.datasetSummary.validationEncounters':
    'Validation encounters',
  'createProjectWizard.step.reviewAndCreate.datasetSummary.trainingEncounters':
    'Training encounters',
  'createProjectWizard.step.reviewAndCreate.datasetSummary.testEncounters': 'Test encounters',
  'createProjectWizard.step.reviewAndCreate.conceptAndAttributes.title':
    'Concept groups & required attributes',
  'createProjectWizard.step.reviewAndCreate.conceptAndAttributes.conceptCountSuffix':
    'concept groups',
  'createProjectWizard.step.reviewAndCreate.allocationSummary.title': 'Allocation summary',
  'createProjectWizard.step.reviewAndCreate.datasetSummary.title': 'Dataset summary',

  // Create project success modal
  'createProjectWizard.step.reviewAndCreate.createSuccessModal.title': 'Create project',
  'createProjectWizard.step.reviewAndCreate.createSuccessModal.alert.title': 'Success',
  'createProjectWizard.step.reviewAndCreate.createSuccessModal.alert.description':
    '"{projName}" was created successfully.',
  'createProjectWizard.step.reviewAndCreate.createSuccessModal.close.message':
    'This window will close automatically in {seconds} seconds',

  // Annotation agent step
  // TODO: cleanup with cp_annotation_createproject_agent ff
  'createProjectWizard.step.annotationAgent.heading': 'Add an annotation agent',
  'createProjectWizard.step.annotationAgent.toggle.description':
    'Add an annotation agent that produces a second, independent annotation on every encounter. Use the prompt builder to configure the prompt.',
  'createProjectWizard.step.annotationAgent.unavailable.notSetUp':
    'The annotation agent is not set up for your organisation. Contact your administrator.',
  'createProjectWizard.step.annotationAgent.unavailable.notAvailable':
    'The annotation agent is not available right now. Contact your administrator.',
  'createProjectWizard.step.annotationAgent.unavailable.canTurnOff':
    'You can turn it off and create the project without the annotation agent.',
  'createProjectWizard.step.annotationAgent.builder.title': 'Prompt builder',
  'createProjectWizard.step.annotationAgent.builder.description':
    'Build a unified concept-extraction configuration on the left and preview the rendered prompt on the right. Concepts are populated automatically from Step 2.',
  'createProjectWizard.step.annotationAgent.builder.model.label': 'Model',
  'createProjectWizard.step.annotationAgent.builder.model.placeholder': 'Select model',
  'createProjectWizard.step.annotationAgent.preview.title': 'Prompt preview',
  'createProjectWizard.step.annotationAgent.preview.updating': 'Updating the prompt preview',
  'createProjectWizard.step.annotationAgent.preview.error':
    'The prompt preview could not be loaded. You can still continue.',
  'createProjectWizard.step.annotationAgent.validation.title': 'Validation',
  'createProjectWizard.step.annotationAgent.validation.notesAdded':
    '<b>{name}</b>: Special notes added.',
  'createProjectWizard.step.annotationAgent.concepts.title': 'Concepts',
  'createProjectWizard.step.annotationAgent.concept.header': '{name} · alias: {alias}',
  'createProjectWizard.step.annotationAgent.concept.expand': 'Expand {name}',
  'createProjectWizard.step.annotationAgent.concept.collapse': 'Collapse {name}',
  'createProjectWizard.step.annotationAgent.concept.edit': 'Edit {name}',
  'createProjectWizard.step.annotationAgent.concept.field.name': 'Concept name',
  'createProjectWizard.step.annotationAgent.concept.field.synonyms': 'Other names',
  'createProjectWizard.step.annotationAgent.concept.field.attributes': 'Attributes',
  'createProjectWizard.step.annotationAgent.concept.field.notes': 'Special notes',
  'createProjectWizard.step.annotationAgent.concept.field.synonyms.draft':
    'Other names this might be called (alternate phrasings or abbreviations)',
  'createProjectWizard.step.annotationAgent.concept.synonyms.placeholder':
    'Add synonyms or subtypes',
  'createProjectWizard.step.annotationAgent.concept.field.attributes.draft':
    'Attributes to extract for this concept',
  'createProjectWizard.step.annotationAgent.concept.attributes.readOnly':
    'Read-only — defined in step 2 (Concept groups & required attributes).',
  'createProjectWizard.step.annotationAgent.concept.attributes.empty':
    'No additional attributes selected in step 2.',
  'createProjectWizard.step.annotationAgent.concept.field.notes.draft':
    'Special notes for the model about this concept',
  'createProjectWizard.step.annotationAgent.concept.notes.placeholder':
    'e.g. Do not assume this concept from comorbidities alone; documentation must state it explicitly.',
  'createProjectWizard.step.annotationAgent.concept.name.required': 'Concept name is required.',
  'createProjectWizard.step.annotationAgent.concept.alias.caption':
    'Alias: {alias} (auto-assigned)',
  'createProjectWizard.step.annotationAgent.concept.synonyms.add': 'Add',
  'createProjectWizard.step.annotationAgent.concept.none': 'None',
  'createProjectWizard.step.annotationAgent.concept.save': 'Save',
  'createProjectWizard.step.annotationAgent.concept.cancel': 'Cancel',
  'createProjectWizard.step.annotationAgent.sections.title': 'Custom prompt sections',
  'createProjectWizard.step.annotationAgent.sections.add': 'Add custom section',
  'createProjectWizard.step.annotationAgent.section.untitled': 'Untitled section',
  'createProjectWizard.step.annotationAgent.section.remove': 'Remove section {name}',
  'createProjectWizard.step.annotationAgent.section.field.heading': 'Section name',
  'createProjectWizard.step.annotationAgent.section.field.body': 'Section body',
  'createProjectWizard.step.annotationAgent.section.heading.required': 'Section name is required.',
  'createProjectWizard.step.annotationAgent.section.body.required': 'Section body is required.',
  'createProjectWizard.step.annotationAgent.section.save': 'Save',
  'createProjectWizard.step.annotationAgent.section.cancel': 'Cancel',

  // People & allocation and Review with the annotation agent on
  // TODO: cleanup with cp_annotation_createproject_agent ff
  // Fixed label for the agent, kept in Title Case as a name rather than the account name.
  'createProjectWizard.step.allocation.agent.label': 'Annotation Agent',
  'createProjectWizard.step.allocation.agent.description':
    'Each encounter is annotated twice: once by the annotation agent and once by a human annotator. Human annotation assignments are evenly distributed across all human annotators.',
  'createProjectWizard.step.allocation.agent.totalAssignments':
    'Total annotation assignments: {encounterCount, number} encounters × 2 = {assignmentCount, number}',
  'createProjectWizard.step.allocation.agent.split':
    'Annotation agent: {agentEncounterCount, number} encounters · Human annotators: {humanEncounterCount, number} encounters',
  'createProjectWizard.step.allocation.agent.loading': 'Counting the encounters to annotate',
  'createProjectWizard.step.allocation.agent.error':
    'The encounters to annotate could not be counted. Try again, or turn off the annotation agent in step 5.',
  'createProjectWizard.step.allocation.agent.noEncounters':
    'The dataset has no encounters with notes for the annotation agent to annotate. Check the uploaded files, or turn off the annotation agent in step 5.',
  'createProjectWizard.step.reviewAndCreate.agent.status.label': 'Annotation agent',
  'createProjectWizard.step.reviewAndCreate.agent.status.on': 'On',
  'createProjectWizard.step.reviewAndCreate.agent.status.off': 'Off',
  'createProjectWizard.step.reviewAndCreate.agent.model.label': 'Model',
  'createProjectWizard.step.reviewAndCreate.agent.basePrompt.label': 'Base prompt',
  'createProjectWizard.step.reviewAndCreate.agent.basePrompt.value': 'Curated from concept groups',
  'createProjectWizard.step.reviewAndCreate.agent.concepts.label': 'Concepts',
  'createProjectWizard.step.reviewAndCreate.agent.specialNotes.label': 'Special notes added',
  'createProjectWizard.step.reviewAndCreate.agent.sections.label': 'Custom prompt sections',
  'createProjectWizard.step.reviewAndCreate.agent.none': 'None',
  'createProjectWizard.step.reviewAndCreate.agent.allocationSummary.batch': 'Batch',
  'createProjectWizard.step.reviewAndCreate.agent.allocationSummary.annotator': 'Annotator',
  'createProjectWizard.step.reviewAndCreate.agent.allocationSummary.encounters':
    'Encounters allocated',
  'createProjectWizard.step.reviewAndCreate.agent.allocationSummary.allBatches': 'All batches',
  'createProjectWizard.step.allocation.agent.custom.description':
    'Each encounter is annotated twice: once by the annotation agent and once by a human annotator. Human annotation assignments are distributed across all human annotators according to the defined percentage split.',
  'createProjectWizard.step.allocation.agent.custom.totalEncounters':
    'Total encounters for annotation: {encounterCount, number} × 2 = {assignmentCount, number}',
  'createProjectWizard.step.allocation.agent.custom.annotator': 'Annotator',
  'createProjectWizard.step.allocation.agent.custom.percent': 'Percent (%)',
  'createProjectWizard.step.allocation.agent.custom.encounters': 'Encounters',
  'createProjectWizard.step.allocation.agent.custom.percentInput': 'Percent for {name}',
  'createProjectWizard.step.allocation.agent.custom.encounterCount':
    '{encounterCount, number} encounters',
  'createProjectWizard.step.allocation.agent.custom.total': 'Total (human)',
  'createProjectWizard.step.allocation.agent.custom.totalError':
    'Percentages must add up to 100%. Current total: {total}%.',
  'createProjectWizard.step.reviewAndCreate.agent.allocationSummary.customShare':
    '{sharePercentage}% · {encounterCount, number} encounters',
};
